/**
 * Returns tour map
 * @param {Object} state the redux store
 * @return {Object} id -> tour
 */
export const getTours = state => state.entities.tours.entities;
